import React from 'react';
import Hero from '../components/Hero';
import WhoItsFor from '../components/WhoItsFor';
import CoreProblem from '../components/CoreProblem';
import HowItWorks from '../components/HowItWorks';
import DeploymentModel from '../components/DeploymentModel';
import WhatItHandles from '../components/WhatItHandles';
import Integrations from '../components/Integrations';
import HonestLimitations from '../components/HonestLimitations';
import ROICalculator from '../components/ROICalculator';
import Pricing from '../components/Pricing';
import FounderSection from '../components/FounderSection';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import BookingCalendar from '../components/BookingCalendar';

const Home = () => (
  <div style={{ background: '#0a0a0a' }}>
    <Hero />
    <WhoItsFor />
    <CoreProblem />
    <HowItWorks />
    <DeploymentModel />
    <WhatItHandles />
    <Integrations />
    <HonestLimitations />
    <ROICalculator />
    <Pricing />
    <FounderSection />
    <FAQ />
    <FinalCTA />
    <BookingCalendar />
  </div>
);

export default Home;